import { APPOINTMENT_TASKS_API_URL } from 'constants/ApiConstants';

import * as actionTypes from './actionTypes';

export const fetchLockerAppointmentTasks = params => ({
  type: actionTypes.FETCH_LOCKER_TASKS,
  payload: {
    request: {
      method: 'GET',
      url: 'appointmentTasks/search/booked',
      params: {
        ...params,
        projection: 'page',
      },
    },
  },
});

export const fetchLockerAppointmentTasksSuccess = (tasks, meta = {}) => ({
  type: actionTypes.FETCH_LOCKER_TASKS_SUCCESS,
  payload: tasks,
  meta,
});

export const fetchLockerAppointmentTasksFailure = error => ({
  type: actionTypes.FETCH_LOCKER_TASKS_FAILURE,
  payload: {
    message: error,
  },
  error: true,
});

export const verify = data => ({
  type: actionTypes.POST_VERIFY,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENT_TASKS_API_URL}/${data.id}/verify`,
      data,
    },
  },
  meta: { id: data.id },
});

export const verifySuccess = (locker, meta = {}) => ({
  type: actionTypes.POST_VERIFY_SUCCESS,
  payload: locker,
  meta,
});

export const verifyFailure = error => ({
  type: actionTypes.POST_VERIFY_FAILURE,
  payload: {
    message: error,
  },
  error: true,
});

export const prepare = data => ({
  type: actionTypes.POST_PREPARE,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENT_TASKS_API_URL}/${data.id}/prepare`,
      data,
    },
  },
  meta: { id: data.id },
});

export const prepareSuccess = (locker, meta = {}) => ({
  type: actionTypes.POST_PREPARE_SUCCESS,
  payload: locker,
  meta,
});

export const prepareFailure = error => ({
  type: actionTypes.POST_PREPARE_FAILURE,
  payload: {
    message: error,
  },
  error: true,
});

export const unprepare = id => ({
  type: actionTypes.POST_UNPREPARE,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENT_TASKS_API_URL}/${id}/unprepare`,
    },
  },
  meta: { id },
});

export const unprepareSuccess = (locker, meta = {}) => ({
  type: actionTypes.POST_UNPREPARE_SUCCESS,
  payload: locker,
  meta,
});

export const unprepareFailure = error => ({
  type: actionTypes.POST_UNPREPARE_FAILURE,
  payload: {
    message: error,
  },
  error: true,
});

const create = (appointmentId, data, meta = {}) => ({
  type: actionTypes.POST_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENT_TASKS_API_URL}`,
      data: {
        appointmentId,
        ...data,
        task: data.task,
      },
    },
    meta: {
      appointmentId,
      ...meta,
    },
  },
});

export const createSuccess = (appointmentId, task) => ({
  type: actionTypes.POST_SUCCESS,
  payload: task,
  meta: {
    appointmentId,
  },
});

export const createFailure = message => ({
  type: actionTypes.POST_FAILURE,
  payload: message,
  error: true,
});

export const createClientDocument = (appointmentId, params) => ({
  ...create(appointmentId, params),
  type: actionTypes.POST_CLIENT_DOCUMENT_REQUEST,
});

export const createBilling = (appointmentId, params) => ({
  ...create(appointmentId, params),
  type: actionTypes.POST_BILLING_TASK_REQUEST,
});

export const createKeyDeposit = (appointmentId, { from, to, type, vaultId }) => ({
  ...create(appointmentId, { task: { from, to, type }, vaultId }),
  type: actionTypes.POST_KEY_DEPOSIT_REQUEST,
});

export const createRepairOrder = (appointmentId, task) => ({
  ...create(appointmentId, task),
  type: actionTypes.POST_REPAIR_ORDER_REQUEST,
});

export const createRentalVehicle = (appointmentId, params) => ({
  ...create(appointmentId, params),
  type: actionTypes.POST_RENTAL_VEHICLE_TASK_REQUEST,
});

export const createKeyRetrieve = (appointmentId, { from, to, type, vaultId }) => ({
  ...create(appointmentId, { task: { from, to, type }, vaultId }),
  type: actionTypes.POST_KEY_RETRIEVE_REQUEST,
});

export const fetchAppointmentTask = id => ({
  type: actionTypes.FETCH_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${APPOINTMENT_TASKS_API_URL}/${id}`,
    },
  },
});

export const fetchAppointmentTaskSuccess = appointmentTask => ({
  type: actionTypes.FETCH_SUCCESS,
  payload: appointmentTask,
});

export const fetchAppointmentTaskFailure = message => ({
  type: actionTypes.FETCH_FAILURE,
  payload: message,
  error: true,
});

const update = (id, appointmentId, { from, to, type, vaultId }) => ({
  type: actionTypes.PUT_REQUEST,
  payload: {
    request: {
      method: 'PUT',
      url: `${APPOINTMENT_TASKS_API_URL}/${id}`,
      data: {
        appointmentId,
        task: {
          type,
          from,
          to,
        },
        vaultId,
      },
    },
    meta: {
      id,
      appointmentId,
    },
  },
});

export const updateSuccess = (appointmentId, task) => ({
  type: actionTypes.PUT_SUCCESS,
  payload: task,
  meta: { appointmentId },
});

export const updateFailure = message => ({
  type: actionTypes.PUT_FAILURE,
  payload: message,
  error: true,
});

export const updateKeyDeposit = (id, appointmentId, { from, to, type, vaultId }) => ({
  ...update(id, appointmentId, { from, to, type, vaultId }),
  type: actionTypes.PUT_KEY_DEPOSIT_REQUEST,
});

export const updateKeyRetrieve = (id, appointmentId, { from, to, type, vaultId }) => ({
  ...update(id, appointmentId, { from, to, type, vaultId }),
  type: actionTypes.PUT_KEY_RETRIEVE_REQUEST,
});

const reschedule = (id, appointmentId, { from, to, type, vaultId }) => ({
  type: actionTypes.RESCHEDULE_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENT_TASKS_API_URL}/${id}/reschedule`,
      data: {
        appointmentId,
        task: {
          type,
          from,
          to,
        },
        vaultId,
      },
    },
    meta: {
      id,
      appointmentId,
    },
  },
});

export const rescheduleSuccess = (appointmentId, task, id) => ({
  type: actionTypes.RESCHEDULE_SUCCESS,
  payload: task,
  meta: { appointmentId, id },
});

export const rescheduleFailure = message => ({
  type: actionTypes.RESCHEDULE_FAILURE,
  payload: message,
  error: true,
});

export const rescheduleKeyDeposit = (id, appointmentId, { from, to, type, vaultId }) => ({
  ...reschedule(id, appointmentId, { from, to, type, vaultId }),
  type: actionTypes.RESCHEDULE_KEY_DEPOSIT_REQUEST,
});

export const rescheduleKeyRetrieve = (id, appointmentId, { from, to, type, vaultId }) => ({
  ...reschedule(id, appointmentId, { from, to, type, vaultId }),
  type: actionTypes.RESCHEDULE_KEY_RETRIEVE_REQUEST,
});

const deleteTask = (id, appointmentId) => ({
  type: actionTypes.DELETE_REQUEST,
  payload: {
    request: {
      method: 'DELETE',
      url: `${APPOINTMENT_TASKS_API_URL}/${id}`,
    },
    meta: {
      id,
      appointmentId,
    },
  },
});

export const deleteTaskSuccess = (id, appointmentId) => ({
  type: actionTypes.DELETE_SUCCESS,
  payload: {
    id,
    appointmentId,
  },
});

export const deleteTaskFailure = message => ({
  type: actionTypes.DELETE_FAILURE,
  payload: message,
  error: true,
});

export const deleteRepairOrder = (id, appointmentId) => ({
  ...deleteTask(id, appointmentId),
  type: actionTypes.DELETE_REPAIR_ORDER_REQUEST,
});

export const deleteRentalVehicle = (id, appointmentId) => ({
  ...deleteTask(id, appointmentId),
  type: actionTypes.DELETE_RENTAL_VEHICLE_TASK_REQUEST,
});

export const deleteKeyDeposit = (id, appointmentId) => ({
  ...deleteTask(id, appointmentId),
  type: actionTypes.DELETE_KEY_DEPOSIT_REQUEST,
});

export const deleteKeyRetrieve = (id, appointmentId) => ({
  ...deleteTask(id, appointmentId),
  type: actionTypes.DELETE_KEY_RETRIEVE_REQUEST,
});

export const deleteClientDocument = (id, appointmentId) => ({
  ...deleteTask(id, appointmentId),
  type: actionTypes.DELETE_CLIENT_DOCUMENT_REQUEST,
});

export const deleteBilling = (id, appointmentId) => ({
  ...deleteTask(id, appointmentId),
  type: actionTypes.DELETE_BILLING_REQUEST,
});

export const deleteMediaSuccess = (appointmentTaskId, mediaId) => ({
  type: actionTypes.DELETE_MEDIA_SUCCESS,
  payload: { appointmentTaskId, mediaId },
});

export const deleteMediaFailure = error => ({
  type: actionTypes.DELETE_MEDIA_FAILURE,
  payload: error,
  error: true,
});

export const postResolveIssue = appointmentTaskId => ({
  type: actionTypes.POST_RESOLVE_ISSUE_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENT_TASKS_API_URL}/${appointmentTaskId}/resolveIssue`,
    },
  },
});

export const postResolveIssueSuccess = task => ({
  type: actionTypes.POST_RESOLVE_ISSUE_SUCCESS,
  payload: task,
});

export const postResolveIssueFailure = message => ({
  type: actionTypes.POST_RESOLVE_ISSUE_FAILURE,
  payload: message,
  error: true,
});

export const acknowledgeIssue = (id, appointmentId) => ({
  type: actionTypes.ACKNOWLEDGE_ISSUE,
  payload: {
    request: {
      method: 'POST',
      url: `${APPOINTMENT_TASKS_API_URL}/${id}/acknowledgeIssue`,
    },
    id,
    appointmentId,
  },
});

export const acknowledgeIssueSuccess = task => ({
  type: actionTypes.ACKNOWLEDGE_ISSUE_SUCCESS,
  payload: task,
});

export const acknowledgeIssueFailure = message => ({
  type: actionTypes.ACKNOWLEDGE_ISSUE,
  payload: message,
  error: true,
});

export const showAddDriverLicence = () => ({ type: actionTypes.SHOW_ADD_DRIVER_LICENCE });

export const hideAddDriverLicence = () => ({ type: actionTypes.HIDE_ADD_DRIVER_LICENCE });

export const addDriverLicence = appointmentId => ({
  type: actionTypes.ADD_DRIVER_LICENCE,
  payload: {
    appointmentId,
  },
});
